// src/components/impact/ImpactLedgerCta.tsx
import React from 'react';
import { motion } from 'framer-motion';
import {Button} from '@dopomogai/ui';
import { BookOpen } from 'lucide-react';

interface LedgerCtaData {
  headline: string;
  text: string;
  buttonText: string;
  buttonAction: {
    type: string;
    payload: any;
  };
}

interface ImpactLedgerCtaProps {
  ledgerCtaData: LedgerCtaData;
  onAction: (actionType: string, payload?: any) => void;
}

export const ImpactLedgerCta: React.FC<ImpactLedgerCtaProps> = ({ ledgerCtaData, onAction }) => {
  return (
    <section className="bg-white py-16 md:py-20">
      {/* --- THE FIX: Added 'relative group' to the animator div --- */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        className="container mx-auto px-4 relative group"
      >
        {/* This div is the shadow that appears on hover */}
        <div className="absolute inset-0 max-w-4xl mx-auto bg-black rounded-xl transition-transform duration-200 ease-out group-hover:translate-x-1 group-hover:translate-y-1" />
        
        {/* This div is the main content that moves */}
        <div className="relative bg-slate-100 border-2 border-black rounded-xl p-8 md:p-12 text-center max-w-4xl mx-auto transition-transform duration-200 ease-out group-hover:-translate-x-1 group-hover:-translate-y-1">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">{ledgerCtaData.headline}</h2>
          <p className="mt-3 text-slate-600 max-w-3xl mx-auto">{ledgerCtaData.text}</p>
          <div className="mt-8">
            <Button
              text={ledgerCtaData.buttonText}
              variant="secondary"
              size="lg"
              icon={<BookOpen size={18} />}
              onClick={() => onAction(ledgerCtaData.buttonAction.type, ledgerCtaData.buttonAction.payload)}
            />
          </div>
        </div>
      </motion.div>
    </section>
  );
};

